import React, { Component } from 'react'
import * as XLSX from 'xlsx';
import BsyAlertQrcode from "../BsyAlertQrcode";
import BsySwitchBtn from "../BsySwitchBtn";
import LoginAccountInput from "../../Login/LoginAccountInput";
import BsyIconBtn from "../BsyIconBtn";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import imgCodeAlert from "../BsyAlertImgCode/Staticize";
import BsyAlert from "../BsyAlert";
import './index.css'
import { BsyUtils } from '../../utils/Utils';
import BsyDialog from '../BsyDialog';
import BsyTooltip from "../BsyTooltip";
import BsyApprovePane from '../BsyApprovePane';
import BsySlidePane from '../BsySlidePane';
import AddUrlLinkPane from '../BsyCorpCoop/AddUrlLinkPane';


class AlertListCorpCoop extends Component {
    constructor(props) {
        super(props);
        this.state = {
            group_id: props.group_id,
            groupname: props.groupname,
            batchInvite: false,
            formRef: true,
            nicknameError: false,
            phoneError: false,
            emailError: false,
            openurl_switch: props.openurl_switch,
            openurl: props.openurl,
            approve_switch: props.approve_switch,
            nickname: "",
            phone: "",
            email: "",
            userUniqueId: "",
            excelName: "",
            excelTotal: "",
            corpId: "",
            errTipShow: false,
            nocheck: props.nocheck,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            err: 0,
            excelTable: [],
            errInfo: [],
            emailCodeLogin: true,
            mobileCodeLogin: true,
            cacheKey: "",
            link: "",
            success: 0,
            linkUrlList: [],
            corpCoopList: props.corpCoopList || [],
            contactList: props.contactList || [],
            corpCoopMap: props.corpCoopMap || {},
            contactMap: props.contactMap || {},
        }
        this.copyCont = React.createRef();
        this.createAddLink = {};
        this.editLink = {};
    }

    componentDidMount() {
        React.axios('/corp/dock/member/join_link', {
            corpId: window.FX.STATIC.corpId
        }).then(res => {
            this.setState({ 
                emailCodeLogin: res.data.emailCodeLogin,
                mobileCodeLogin: res.data.mobileCodeLogin,
            },()=>{
                this.reLoad();
            })
        })
    }

    reLoad = () =>{
        React.axios('/corp/dock/link/list', {
            corpId: window.FX.STATIC.corpId
        }).then(res => {
            this.setState({
                linkUrlList: res.data
            })
        }).catch(res => {

        })
    }


    switchBody = (event) => {
        if (event.target.classList[0] === "menu-item") {
            for (let i = 0; i < event.target.parentNode.childNodes.length; i++) {
                event.target.parentNode.childNodes[i].classList.remove("active")
            }
            event.target.classList.add("active")
            if (event.target.classList[1] === "batchInvite") {
                this.setState({
                    batchInvite: true,
                    formRef: false
                })
            } else if (event.target.classList[1] === "formRef") {
                this.setState({
                    batchInvite: false,
                    formRef: true
                })
            }
        }
    }

    changeNickname = (event) => {
        const { value } = event.target
        this.setState({
            nickname: value,
            nicknameError: false
        })
    }

    changeUserUniqueId = (event) => {
        const { value } = event.target
        this.setState({
            userUniqueId: value
        })
    }

    changePhone = (event) => {
        const { value } = event.target
        this.setState({
            phone: value,
            phoneError: false
        })
    }

    emailValue = (rel) => {
        this.getEmail = rel
    }

    changeEmail = (event) => {
        const { value } = event.target
        this.setState({
            email: value,
            emailError: false
        })
    }

    handleCopy = () => {
        const spanText = this.copyCont.current.innerText;
        BsyUtils.copyToClipboard(spanText)
        tipAlert({
            type: "success",
            msg: React.language('app.edit.copy.success')
        });
    };

    manualClear = () => {
        this.setState({
            nickname: "",
            phone: "",
            userUniqueId: "",
        })
    }

    inviteClick = () => {
        const { nickname, userUniqueId, group_id, mobileCodeLogin, emailCodeLogin } = this.state
        let countryCode = this.getPhone.state.countryCode || '+86';
        let phone = this.getPhone.state.value;
        let email = this.getEmail.state.value;
        let requiredTip = "";

        if (nickname === "") {
            this.setState({ nicknameError: true })
            return
        }

        if((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin) ){
            requiredTip = React.language('invite.phone.and.email.required')
        }else if(!emailCodeLogin && mobileCodeLogin){
            requiredTip = React.language('invite.phone.required')
        }else if(emailCodeLogin && !mobileCodeLogin){
            requiredTip = React.language('invite.email.required')
        }

        if ((emailCodeLogin && mobileCodeLogin) || (!emailCodeLogin && !mobileCodeLogin) ) {
            if (!email && !phone) {
                this.setState({ emailError: false, phoneError: false }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                return
            }
        } else {
            if (!phone && mobileCodeLogin) {
                this.setState({ phoneError: false }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                return
            }
            if(!email && emailCodeLogin){
                this.setState({ emailError: false }, () => {
                    tipAlert({
                        type: 'warning',
                        msg: requiredTip
                    })
                })
                return
            }
        }


        ///corp/invite_check
        React.axios('/corp/invite_check', {}).then(res => {

            if (!res.data.check) {
                React.axios('/corp/outsider/invite', {
                    "name": nickname,  //必填 12 以内
                    "mobile": phone,  //必填
                    email: this.getEmail ? this.getEmail.state.value : null,
                    "country_code": countryCode, //必填
                    "uniqueid": userUniqueId,   //用户唯一id  32位以内
                    "group_id": group_id, //分组 必填
                }).then(res => {
                    BsyUtils.showAjaxTip(res.data, () => {
                        const { target, onRefresh } = this.props;
                        target.parentNode.remove();
                        tipAlert({
                            type: "success",
                            msg: res.data.msg
                        });
                        if (onRefresh) {
                            onRefresh();
                        }
                    })
                }).catch(res => {

                })
            } else {
                imgCodeAlert({
                    type: "success",
                    title: React.language('verification.img.code'),
                    onOk: (args) => {
                        if (!args.value) {
                            tipAlert({
                                type: "warning",
                                msg: React.language('code.not.empty')
                            });
                            return;
                        }
                        React.axios('/corp/outsider/invite', {
                            "name": nickname,  //必填 12 以内
                            "mobile": phone,  //必填
                            email: this.getEmail ? this.getEmail.state.value : null,
                            "country_code": countryCode, //必填
                            "uniqueid": userUniqueId,   //用户唯一id  32位以内
                            "group_id": group_id, //分组 必填
                            "ver_code": args.value //验证码
                        }).then(res => {
                            BsyUtils.showAjaxTip(res.data, () => {
                                const { target, onRefresh } = this.props;
                                if (args.onClose) {
                                    args.onClose()
                                }
                                if (onRefresh) {
                                    onRefresh();
                                }

                                target.parentNode.remove();
                                tipAlert({
                                    type: "success",
                                    msg: res.data.msg
                                });
                            }, () => {
                                //出错，重置验证码
                                if (args.onClose) {
                                    args.onClose()
                                }
                            })
                        }).catch(res => {
                            if (args.onClose) {
                                args.onClose()
                            }
                        })

                    }
                })
            }

        }).catch(res => {

        })



    }

    _column_2_number = (s) => {
        let result = 0;
        let len = s.length;
        let ch;
        let A = 'A'.charCodeAt();
        for (let i = len - 1; i >= 0; i--) {
            ch = s[i];
            ch = s.charCodeAt(i);
            result = (result + ((ch - A) + 1) * Math.pow(26, len - 1 - i));
        }
        return result;
    }

    _parse_sample_ex2 = (a) => {
        let y_s = 0;
        let x_e = 0;
        let y_e = 0;
        let ref = a['!ref']
        let reg1 = /([a-zA-Z]+)([0-9]+):([a-zA-Z]+)([0-9]+)/ig;
        let res1 = reg1.exec(ref)
        y_s = Number(res1[2]) - 1;
        x_e = this._column_2_number(res1[3]);
        y_e = Number(res1[4]);
        let result = new Array(y_e > 500 ? 500 : y_e);
        let array_value = new Array(y_e);
        for (let i = y_s; i < y_e; i++) {
            array_value[i] = [];
            if (i < 500)
                result[i] = [];
            for (let j = 0; j < x_e; j++) {
                array_value[i][j] = "";
                if (i < 500)
                    result[i][j] = {};
            }
        }
        for (let k in a) {
            let reg = /([a-zA-Z]+)([0-9]+)/ig;
            let res = reg.exec(k)
            if (!res)
                continue;
            let x = this._column_2_number(res[1]) - 1;
            let y = Number(res[2]) - 1;
            let val = { value: a[k].v, type: a[k].t };
            if (y < 500)
                result[y][x] = val;
            array_value[y][x] = a[k].v;
        }
        this.setState({
            array_value: array_value,
            excelTotal: array_value.length - 1
        })
        return result;
    }

    _previewExcelData = (a1, event) => {
        const txt = React.language('role.import.tip');
        // eslint-disable-next-line no-unused-vars
        let { cacheKey, sheetName, formName, excel_data, cuurmobiletype } = this.state
        let wb;
        let f = a1[0];
        let reader = new FileReader();
        reader.onload = (e) => {
            const data = e.target.result;
            wb = XLSX.read(data, { type: 'binary' });
            cacheKey = a1.cacheKey;
            sheetName = wb.SheetNames[0];
            var b = a1;
            a1 = [];
            a1.sheetList = wb.SheetNames;
            formName = React.language("import.form");
            if (b && b.length > 0) {
                formName = b[0].name.replace(".xlsx", "").replace(".xls", "");
                if(b[0].size > 5242880){
                    tipAlert({
                        type: "warning",
                        msg: React.language('upload.maxSizeTip',{size: 5})
                    })
                    return
                }
                // if (wb.Sheets[sheetName].hasOwnProperty("!merges")) {
                //     tipAlert({
                //         type: "warning",
                //         msg: txt
                //     });
                //     event && (event.target.value = '');
                // }
                // else {
                    //必填手机号码，手机号码为空直接过滤当前数据
                    excel_data = wb.Sheets;
                    let items = this._parse_sample_ex2(wb.Sheets[sheetName]), g = true;
                    let array_value = [];
                    cuurmobiletype = false;
                    if (items.length > 0) {
                        //unique
                        if (g) {
                            if ((array_value.length - 1) <= 200) {
                                this.setState({ excelName: f.name.replace(".xlsx", "").replace(".xls", ""), excelTable: items }, ()=>{
                                    this.importClick();
                                })
                                event && (event.target.value = '');
                            } else {
                                tipAlert({
                                    type: "warning",
                                    msg: '数据条数超过限制，最大值为200条'
                                });
                                event && (event.target.value = '');
                            }
                        } else {
                            tipAlert({
                                type: "warning",
                                msg: txt
                            });
                            event && (event.target.value = '');
                        }
                    } else {
                        tipAlert({
                            type: "warning",
                            msg: txt
                        });
                        event && (event.target.value = '');
                    }
                // }
            }
        }

        reader.readAsBinaryString(f);
    }

    uploadFile = (event, file) => {

        const img = event ? event.target.files : file;
        this._previewExcelData(img, event);
    }

    downFile = () => {
        window.location.href = window.rootDirectroy + '/wps/' + React.language('wps.xlsx.name2')
    }

    importClick = () => {
        const { excelTable, group_id } = this.state
        const c = window.FX.Utils.createLoadLayer(window.$('.invite-body'), {
            isLight: !0,
            hasLoader: !0
        });
        React.axios("/corp/dock/corp/import", {
            excel: excelTable,
            group_id: group_id
        }).then(res => {
            c.remove()
            const data = res.data
            if (data.hasOwnProperty("msg") && data.hasOwnProperty("code") && data.code > 0) {
                tipAlert({
                    type: "warning",
                    msg: data.msg
                })
                return;
            }

            var t = data.data;
            if (t.success > 0) {
                this.setState({
                    err: t.err,
                    errInfo: t.errinfo,
                    excelTable: t.info,
                    errCount: t.errcount,
                    existCount: t.existcount,
                    newCount: t.newcount,
                    success: t.success,
                    link: t.link,
                    errTipShow: true
                })
                if (t.newcount > 0) {

                    const { onRefreshAll } = this.props;
                    if (onRefreshAll) {
                        onRefreshAll();
                    }
                }
            } else {
                // tipAlert({
                //     type: "warning",
                //     msg: '系统错误，导入失败'
                // })
            }
        }).catch(res => {

        })
    }

    downErrorInfo = () => {
        const { errInfo } = this.state
        React.axios("/corp/outsider/downloaderr", {
            excel: errInfo
        }).then(res => {
            var h = res.data.data;
            if (h.success > 0) {
                window.location.href = h.info;
            }
        }).catch(res => {

        })
    }

    doneClick = () => {
        this.setState({
            batchInvite: true,
            formRef: false,
            nicknameError: false,
            phoneError: false,
            showLink: false,
            nocheck: false,
            nickname: "",
            phone: "",
            userUniqueId: "",
            excelName: "",
            excelTotal: "",
            corpId: "",
            errTipShow: false,
            errCount: 0,
            existCount: 0,
            newCount: 0,
            excelTable: [],
            errInfo: [],
            cacheKey: "",
            link: ""
        })
    }

    qrcodeAlert = (event) => {
        event.stopPropagation()
        const pot = event.currentTarget.getBoundingClientRect()
        const css = 160 > (document.documentElement.clientHeight - pot.top + event.currentTarget.offsetHeight + 2) ? {
            left: pot.left + 'px',
            minWidth: event.currentTarget.offsetWidth,
            bottom: document.documentElement.clientHeight - pot.top + 2 + 'px'
        } : {
            left: pot.left + 'px',
            minWidth: event.currentTarget.offsetWidth,
            top: pot.top + event.currentTarget.offsetHeight + 2 + 'px'
        }
        const { openurl } = this.state
        BsyAlertQrcode({
            value: openurl,  //value参数为生成二维码的链接
            size: 160, //二维码的宽高尺寸
            css: css,
            text: "扫描二维码，分享给好友",
            fgColor: "#000000"
        })
    }

    phoneValue = (rel) => {
        this.getPhone = rel
    }

    closeAlter = () => {
        const { target } = this.props;
        target.parentNode.remove();
    }

    switchChange = (val) => {

        React.axios('/corp/outsider/update', {
            openurl_switch: val,
            group_id: this.state.group_id
        }).then(res => {
            this.setState({ openurl_switch: val })
            const { onRefreshOusiders } = this.props;
            if (onRefreshOusiders) {
                onRefreshOusiders({ openurl_switch: val });
            }
        }).catch(res => {

        })
    }

    approve_switch_Change = (val, res) => {

        React.axios('/corp/dock/link/update', {
            status: val,
            key: res.key
        }).then(res => {
            this.reLoad()
        }).catch(res => {
            this.reLoad()
        })
    }

    approve_list = (val) => {

        const { group_id, groupname } = this.state
        BsyDialog({
            title: React.language('outsiderGroup') + ' - ' + groupname,
            height: 600,
            width: 966,
            noFooter: true,
            onContentCreate: () => {
                return <BsyApprovePane
                    group_id={group_id} mode={'outsider'} status={3} />

            }
        })

    }

    openQrCode = (event, res) =>{
        let teamName = "";
        const $ = window.$;
        const FX = window.FX;
        FX.STATIC["corps"].map((val)=>{
            if(val.id === FX.STATIC.corpId){
                teamName = val.name;
            }
        })
        let dd = $('<div class="qrCode-img" />');
        new window.QRCode(dd[0], {
            text: res,
            width: 100,
            height: 100
        })
        FX.Msg.bubble({
            anchor: $(event.target),
            contentHTML: $("<div class='qrLink-pane' />").append($("<div class='qrCode-team-name' />").attr("title", teamName).text(teamName)).append($("<div class='qrCode-title' />").text(React.language('invite.link'))).append($("<div class='qrCode-msg' />").text(React.language("member.invite.qrcode.brief",{productName: window._bby_config.site_name}))).append(dd).append($("<div class='qrCode-downloading' />").on("click",function(){FX.Utils.downloadQR(React.language("invite.link"),dd.find("img").attr("src"));}).text(React.language("qrCode.download"))),
            text4Cancel: null,
            text4Ok: null,
            dockPosition: "center",
            hAdjust: 122,
            minWidth: 260,
            contentPadding: 0,
            edge: 300
        })
    }

    openAddUrlLink = () =>{
        const {contactList, corpCoopList} = this.state;
        this.createAddLink = {
            is_tmp_owner: true,
            status: true,
            label_id: "",
            role_id: []
        };
        BsyDialog({
            title: React.language('link.add'),
            height: 490,
            width: 460,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AddUrlLinkPane 
                    isCoop={true} 
                    getCorpCoopValue={this.getCorpCoopValue}
                    contactList={contactList} 
                    corpCoopList={corpCoopList}
                    getValue={this.getLinkValue}
                 />
            },
            onOk: ()=>{
                this.craeteDockLink();
            }
        })
    }

    openEditUrlLink = (res) =>{
        const {contactList, corpCoopList} = this.state;
        const _this = this;
        this.editLink = {
            is_tmp_owner: res.is_tmp_owner,
            status: res.status,
            label_id: res.label_id,
            key: res.key,
            role_id: res.role_id
        };
        BsyDialog({
            title: React.language('link.edit'),
            height: 490,
            width: 460,
            noFooter: false,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return <AddUrlLinkPane 
                    isCoop={true} 
                    getCorpCoopValue={this.getCorpCoopValue}
                    contactList={contactList} 
                    corpCoopList={corpCoopList} 
                    getValue={this.getLinkEditValue}
                    is_tmp_owner= {res.is_tmp_owner}
                    status={res.status}
                    label_id={res.label_id}
                    role_id={res.role_id}
                 />
            },
            onOk: ()=>{
                _this.editDockLink(res);
            }
        })
    }

    editDockLink = (res) =>{
        const _this = this;
        React.axios("/corp/dock/link/update",{...this.editLink, key: res.key}).then(res => {
            tipAlert({
                type: "success",
                msg: React.language('datahelper.trigger.output.filter.ok.tip')
            })
            _this.reLoad()
        })
    }

    craeteDockLink = () =>{
        const _this = this;
        React.axios("/corp/dock/link/create",{...this.createAddLink}).then(res => {
            if(res.data.errcode === 1){
                tipAlert({
                    type: "warning",
                    msg: res.data.errmessage
                })
                return
            }
            window.FX.Msg.alert({
                type: "success",
                title: React.language("configuration.success"),
                msg: React.language("member.invite.public.link.success.tip"),
                text4Ok: React.language("link.copy"),
                text4Cancel: React.language("link.not.yet"),
                onOk: function () {
                    _this.copyLinkUrl(res.data.link)
                    _this.reLoad()
                },
                onCancel: function () {
                    _this.reLoad()
                }
            })
        })
    }

    openRemoveUrlLink = (res) =>{
        const _this = this;
        React.axios("/corp/dock/link/delete",{key: res.key}).then(res => {
            _this.reLoad()
        })
    }

    getLinkValue = (val) =>{
        return this.createAddLink = val;
    }

    getLinkEditValue = (val) =>{
        return this.editLink = val;
    }

    copyLinkUrl = (res) =>{
        let text = React.language("member.invite.copy.link",{productName: window._bby_config.site_name, link: res, name: window.FX.STATIC.user.nickname});
        let input = document.createElement('textarea'); // 新增一个input
        input.style.position = 'relative'; // 将它隐藏（注意不能使用display或者visibility，否则粘贴不上）
        input.style.opacity = '0';
        input.style.zIndex = '-9';
        document.body.appendChild(input); // 追加
        input.value = text; // 设置文本框的内容
        input.select();// 选中文本
        document.execCommand("copy"); // 执行浏览器复制命令
        
        tipAlert({
            type: "success",
            msg: React.language('link.copySuccess')
        });
        input.style.display = 'none';
    }

    openFileDialog = () =>{
        document.getElementById("file").click();
    }

    getFileDrop = (e) =>{
        e.preventDefault();
        e.stopPropagation();
        
        let df = e.dataTransfer;
        let dropFiles = []; // 存放拖拽的文件对象
        
        if(df.items !== undefined) {
          // Chrome有items属性，对Chrome的单独处理
          for(let i = 0; i < df.items.length; i++) {
            let item = df.items[i];
            // 用webkitGetAsEntry禁止上传目录
            if(item.kind === "file" && item.webkitGetAsEntry().isFile) {
                let file = item.getAsFile();
                dropFiles.push(file);
            }
          }
        }
        this.uploadFile(null, dropFiles)
    }

    openDetailUpload = () =>{
        const {excelTable, excelName, errTipShow, excelTotal} = this.state;
        BsySlidePane({
            title: React.language('invite.import.fail.detail'),
            hasHeader: true,
            onContentCreate: (ref) => {
                return (
                    excelTable.length > 0 && <div className="batchTable">
                        <div className="invite-content">
                            <div className="excel-import-tool">
                                <span>{React.language('excel')}-{excelName}</span>
                                {/* <span style={{ float: 'right' }}>{React.language("Total.data")}{excelTotal}{React.language('tiao')}</span> */}
                            </div>
                            <div className="excel-import-table">
                                <div className={"excel-import-grid react_excel_grid " + (errTipShow ? "import" : "")}>
                                    <div className="excel-border">

                                    </div>
                                    <table cellPadding="0" cellSpacing="0">
                                        <tbody>
                                            <tr className="row-head">
                                                <td className="row-idx" rowSpan="1"><span
                                                    className="row-num">1</span><span
                                                        className="row-label">{React.language('import.rowHead')}</span>
                                                </td>
                                                {
                                                    excelTable[0].map((val, key) => {
                                                        return <td key={key}><span>{val.value}</span></td>
                                                    })
                                                }
                                            </tr>
                                            {
                                                excelTable.map((val, key) => {
                                                    return key !== 0 && <tr key={key}>
                                                        <td className="row-idx" rowSpan="1"><span
                                                            className="row-num">{key + 1}</span><span
                                                                className="row-label">{React.language('import.rowHead')}</span>
                                                        </td>
                                                        {
                                                            val.map((val1, key1) => {
                                                                return <td key={key1} title={val1.value}><span>{val1.value}</span></td>
                                                            })
                                                        }
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            },
        })
    }

    render() {
        const { err, batchInvite, formRef, nickname, phone, userUniqueId, nicknameError, phoneError, excelName, excelTotal, excelTable,
            errTipShow, errCount, newCount, linkUrlList, contactMap, corpCoopMap } = this.state
        const { title, styleCss } = this.props;
        let tipText = "";
        let hasError = false;
        if(newCount === 0 && errCount === 0 && err === 0){
            tipText = React.language('error.19014');
        }else if(newCount > 0 && errCount === 0 && err === 0){
            tipText = React.language('corp.import.complete',{count: newCount});
        }else if(newCount === 0 && errCount > 0 && err === 0){
            tipText = React.language('error.19014');
        }else if(newCount === 0 && errCount === 0 && err > 0){
            tipText = React.language('error.19014');
        }else if(newCount > 0 && errCount > 0 && err === 0){
            tipText = React.language('corp.import.complete.docker.fail',{count: newCount});
            hasError = true;
        }else if(newCount === 0 && errCount > 0 && err > 0){
            tipText = React.language('error.19014');
        }else if(newCount > 0 && errCount > 0 && err > 0){
            tipText = React.language('corp.import.complete.docker.fail',{count: newCount});
            hasError = true;
        }else if(newCount > 0 && errCount === 0 && err > 0){
            tipText = React.language('corp.import.not.complete',{successCount: newCount,failCount: err});
        }
        return (
            <div className={"content " + window.mode} style={styleCss}>
                <div className="dialog-header">
                    <span className="title">{title}</span>
                    <i onClick={this.closeAlter} className="icon-close-large" />
                </div>
                <div className="dialog-body">
                    <div className="invite-menu" onClick={this.switchBody}>
                        <div className="menu-item formRef active">{React.language('member.invite.public.link')}</div>
                        <div className="menu-item batchInvite">{React.language('contact.connection.new.multi')}</div>
                    </div>
                    <div className="invite-body">
                        {batchInvite && <div className="batchInvite">
                            <div className="invite-tip">
                                <div className="invite-title">
                                    {React.language('contact.template.corp.cooperation.title')}
                                </div>
                                <div className="invite-tip-text">
                                    <div className="tip-text">
                                        {React.language('contact.template.corp.cooperation.tip.1',{productName: window._bby_config.site_name})}
                                    </div>
                                    {/* <a href="#" className="tip-href">
                                        {React.language('learnMore')}
                                    </a> */}
                                </div>
                            </div>
                            <div className="invite-file-cont">
                                <div className="invite-title">
                                    {React.language('import') + " Excel"}
                                </div>
                                <div className="invite-file">
                                    {errTipShow ? <div className="errorTipCont">
                                        <div className="tipCont">
                                            <div className="tipIcon">
                                                <i className={newCount > 0 ? "icon-bsy-reportmenu-2" : "icon-bsy-error-tip"}></i>
                                            </div>
                                            <div className="tipText" style={newCount === 0 ? {color: 'var(--bsy-base-error-color)'} : {}} dangerouslySetInnerHTML={{__html: tipText}}>
                                            </div>
                                            <div className="tipButtonList">
                                                {(err > 0 || errCount > 0) && <div className={"tipButton " + (hasError ? "lookDetail" : "done")} onClick={this.openDetailUpload}>
                                                    {React.language("view.detail")}
                                                </div>}
                                                <div className={"tipButton " + (newCount === 0 ? "re" : "done")} onClick={this.doneClick}>
                                                    {newCount === 0 ? React.language("upload.redo") : React.language("done")}
                                                </div>
                                            </div>
                                        </div>
                                    </div> : <div className="file-cont" onDrop={this.getFileDrop} onDragOver={e => e.preventDefault()} onClick={this.openFileDialog}>
                                        <div className="file-upload-tip">
                                            <i className="icon-widget-upload"></i>
                                            <span>{React.language("file.select.detail",{num: 5})}</span>
                                            <form className="upload-form " action="" encType="multipart/form-data"
                                                method="post">
                                                <input onChange={this.uploadFile} style={{display: 'none'}} type="file" name="file" id="file"
                                                    className="upload-btn-input" accept=".xlsx,.xls" />
                                            </form>
                                        </div>
                                    </div>}
                                    {(errCount > 0 || err > 0 || !errTipShow) && <div className="file-mould" style={{top: errTipShow ? "230px" : ""}}>
                                        <div className="downMould" onClick={this.downFile}>{React.language('contact.template.download')}</div>
                                    </div>}
                                </div>
                            </div>
                            <div className="invite-file-msg">
                                <div className="fileMsg">
                                    {React.language('contact.template.import.after')}
                                </div>
                                {/* <div className="fileMsg">
                                    {React.language('contact.template.import.link')}
                                </div> */}
                            </div>
                            {/* <div className="invite-file-link">
                                {(success > 0 && link) ? <div className="share-link-pane">
                                    <div className="invite-link">
                                        {link}
                                    </div>
                                    <div className="invite-btn">
                                        <div className="share-btn" onClick={()=>{this.copyLinkUrl(link)}}>{React.language('copy')}</div>
                                        <i className="icon-widget-qrcode" onClick={(event)=>{
                                            this.openQrCode(event, link);
                                        }} onMouseEnter={(event) => {
                                            window.FX.UI.showPopover({
                                            position: "top",
                                            anchor: window.$(event.target),
                                            content: window.$("<span/>").text(React.language('link.qrcode')),
                                            })
                                        }} onMouseLeave={() => {
                                            window.FX.UI.closePopover()
                                        }}></i>
                                    </div>
                                </div> :
                                <div className="link-empty">
                                    {React.language('create.after.excel.import')}
                                </div>}
                            </div> */}
                        </div>}
                        {formRef && <div className="form-ref">
                            <div className="form-ref-item">
                                <div className="item-title">
                                    <span>{React.language('member.invite.public.tip.title')}</span>
                                </div>
                                <div className="item-tip-list">
                                    <div className="tip-item">1.{React.language('member.invite.public.tip1',{productName: window._bby_config.site_name})}</div>
                                    <div className="tip-item">2.{React.language('member.invite.public.tip2',{productName: window._bby_config.site_name})}</div>
                                    <div className="tip-item">3.{React.language('member.invite.public.tip3',{productName: window._bby_config.site_name})}</div>
                                </div>
                            </div>
                            <div className="form-ref-item">
                                <div className="item-title">
                                    <span>{React.language('member.invite.public.setLink')}</span>
                                </div>
                                <div className="item-tip-list">
                                    <div className="tip-item">{React.language('member.invite.public.setLink.text')}</div>
                                </div>
                                <div className="item-add-url">
                                    <div className="url-add-btn">
                                        <div className="add-btn" onClick={this.openAddUrlLink}>
                                            <i className="icon-add"></i>
                                            <span>{React.language('link.add')}</span>
                                        </div>
                                    </div>
                                    <div className="url-list">
                                        {
                                            linkUrlList.length > 0 ? linkUrlList.map(res =>{
                                                return <div className="url-item">
                                                    <div className="url-item-header">
                                                        <div className="header-utl">{res.link}</div>
                                                        <div className="icon-pane">
                                                            <div className="edit-btn icon-btn">
                                                                <i className="icon-bsy-reportmenu-1" onMouseEnter={(event) => {
                                                                    window.FX.UI.showPopover({
                                                                    position: "top",
                                                                    anchor: window.$(event.target),
                                                                    content: window.$("<span/>").text(React.language('link.edit')),
                                                                    })
                                                                }} onMouseLeave={() => {
                                                                    window.FX.UI.closePopover()
                                                                }} onClick={()=>{
                                                                    this.openEditUrlLink(res)
                                                                }}></i>
                                                            </div>
                                                            <div className="remove-btn icon-btn">
                                                                <i className="icon-bsy-reportmenu-9" onMouseEnter={(event) => {
                                                                    window.FX.UI.showPopover({
                                                                    position: "top",
                                                                    anchor: window.$(event.target),
                                                                    content: window.$("<span/>").text(React.language('delete')),
                                                                    })
                                                                }} onMouseLeave={() => {
                                                                    window.FX.UI.closePopover()
                                                                }} onClick={()=>{
                                                                    this.openRemoveUrlLink(res)
                                                                    window.FX.UI.closePopover()
                                                                }}></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="url-item-body">
                                                        <div className="url-body-title">{React.language('contact.connection.link.tip')}</div>
                                                        <div className="url-body-list">
                                                            <div className="link-item-box">
                                                                <div className="link-item-title">{React.language('persona.corp.dept.label')}</div>
                                                                <ul className="link-item-list">
                                                                    <li className="link-item">{corpCoopMap[res.label_id] ? corpCoopMap[res.label_id].name : ""}</li>
                                                                </ul>
                                                            </div>
                                                            <div className="link-item-box">
                                                                <div className="link-item-title">{React.language('contact.handover.role')}</div>
                                                                <ul className="link-item-list">
                                                                    {
                                                                        res.role_id && res.role_id.length > 0 && res.role_id.map(res1 =>{
                                                                            return <li className="link-item">{contactMap[res1] ? contactMap[res1].name : ""}</li>
                                                                        })
                                                                    }
                                                                    
                                                                </ul>
                                                            </div>
                                                            <div className="link-item-box">
                                                                <div className="link-item-title">{React.language('manager.contactAuth')}</div>
                                                                <ul className="link-item-list">
                                                                    <li className="link-item">{res.is_tmp_owner ? React.language('contact.escrow') : React.language('escrow.disabled')}</li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="url-item-footer">
                                                        <BsySwitchBtn power={res.status} switchChange={(e)=>{
                                                            this.approve_switch_Change(e, res)
                                                        }}  />
                                                        <div className="share-link-pane">
                                                            <i className="icon-widget-qrcode" onClick={(event)=>{
                                                                this.openQrCode(event, res.link);
                                                            }} onMouseEnter={(event) => {
                                                                window.FX.UI.showPopover({
                                                                position: "top",
                                                                anchor: window.$(event.target),
                                                                content: window.$("<span/>").text(React.language('link.qrcode')),
                                                                })
                                                            }} onMouseLeave={() => {
                                                                window.FX.UI.closePopover()
                                                            }}></i>
                                                            <div className="share-btn" onClick={()=>{this.copyLinkUrl(res.link)}}>{React.language('link.share')}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }) : <div>

                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }
}

export default AlertListCorpCoop